import type { AxiosInstance } from 'axios';
import { BaseService } from './BaseService';
import type {
  ListingComplaintTypeViewModel,
  ListingComplaintTypeCreateModel,
  ListingComplaintTypeUpdateModel,
} from '../types/listing-complaint-type';
import { apiClient } from '../client/client';

export class ListingComplaintTypeService extends BaseService<
  ListingComplaintTypeViewModel,
  ListingComplaintTypeCreateModel,
  ListingComplaintTypeUpdateModel,
  ListingComplaintTypeViewModel[]
> {
  private static readonly BASE = '/api/listing-complaint-type';

  constructor(client: AxiosInstance = apiClient) {
    super(client, ListingComplaintTypeService.BASE);
  }
}

export const listingComplaintTypeService = new ListingComplaintTypeService();
